import React from "react";
import { Text, View, StyleSheet, Image } from "@react-pdf/renderer";
import { TTrip } from "../../../../types/TripTypes";
import moment from "moment";
import visaIcon from "../../../../assets/images/Visa.png";
import AmericanExpress from "../../../../assets/images/AmericanExpress.png";
import MasterCard from "../../../../assets/images/MasterCard.png";
import Visa from "../../../../assets/images/Visa.png";
import Discover from "../../../../assets/images/Discover.png";
import { CreditCardDetails } from "../../../../types/PaymentTypes";
import { IDownloadPdfTrips } from "../../../../types/DownloadPdfTypes";

const styles = StyleSheet.create({
  row: {
    flexDirection: "row",
    marginBottom: 10,
  },
  card: {
    border: "1px solid #D9D9D9",
    padding: 16,
    borderRadius: 10,
    marginBottom: 16,
  },
  normalText20: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  boldText14: {
    fontSize: 14,
    fontWeight: 700,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
    color: "#000",
  },
  boldText16: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
    color: "#000",
  },
  normalText16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  totalNormalText16: {
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
    color: "#2E2F32",
  },
  normalText14: {
    fontSize: 14,
    fontWeight: 400,
    lineHeight: 1.4,
    fontFamily: "Helvetica",
  },
  tripTextColor: {
    color: "#2E2F32",
    width: 270,
  },
  legCostsAlign: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  overallCostAlign: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  solidDivider: {
    borderTop: "1px solid #D9D9D9",
    marginVertical: 8,
  },
  totalCostContainer: {
    paddingLeft: "16px",
  },
  costSeperationOrderDashed: {
    borderTop: "1px dashed #0063AF",
    marginVertical: 8,
  },
  expireTextStyle: {
    fontSize: 14,
    fontFamily: "Helvetica",
    color: "#2E2F32",
    fontWeight: 400,
    fontStyle: "normal",
    marginBottom: 4,
  },
});

type prop = {
  trips: IDownloadPdfTrips;
  CreditCardDetails?: CreditCardDetails;
};

const cardImages: Record<string, string> = {
  AmericanExpress: AmericanExpress,
  MasterCard: MasterCard,
  Visa: Visa,
  Discover: Discover,
};

const DownloadPdfPaymentCard: React.FC<prop> = ({
  trips,
  CreditCardDetails,
}) => {
  const cardImageSource =
    CreditCardDetails && cardImages[CreditCardDetails?.kind];

  const totalTripCost = trips.reduce((total, trip) => {
    return total + (trip.tripCost ?? 0);
  }, 0);

  return (
    <View style={styles.card}>
      <View style={[styles.row, styles.normalText20]}>
        <Text>Payment</Text>
        <View style={{ flex: 1 }} />
      </View>
      {trips.map((leg, i) => {
        const tripCostTotal =
          (leg.levelOfServiceCost ?? 0) +
          (leg.transportationCost ?? 0) +
          (leg.vehicleTypeCost ?? 0);

        return (
          <View
            key={i}
            style={[styles.row, styles.boldText14, styles.legCostsAlign]}
          >
            <Text>Trip {i + 1}</Text>
            <Text style={styles.boldText16}>${leg?.tripCost?.toFixed(2)}</Text>
          </View>
        );
      })}

      <View style={styles.solidDivider} />
      <View style={styles.totalCostContainer}>
        <View
          style={[
            styles.row,
            styles.totalNormalText16,
            styles.overallCostAlign,
          ]}
        >
          <Text>Total cost</Text>
          <Text>${totalTripCost.toFixed(2)}</Text>
        </View>
        <Text style={[styles.normalText14, styles.tripTextColor]}>
          You'll only be charged after each individual trip is complete.
        </Text>
      </View>
      <View style={styles.costSeperationOrderDashed} />

      <View style={[styles.row, styles.normalText16]}>
        <Text>Saved card</Text>
      </View>
      <View>
        <View style={styles.row}>
          <Image
            src={cardImageSource}
            style={{ width: 40, height: 25, marginRight: 8, marginTop: 7 }}
          />
          <View>
            <Text style={styles.boldText14}>
              **** {CreditCardDetails?.last4}
            </Text>
            <Text style={styles.expireTextStyle}>
              Expires {moment(CreditCardDetails?.expiresOn).format("MM/YYYY")}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
};

export default DownloadPdfPaymentCard;
